import {HttpClient, HttpParams} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {IOrdersDetails} from '@app/checkout/models/order-details.model';
import {Order} from '@app/checkout/models/order-request.model';
import {IMyOrderRequestModel} from '@app/order/models/my-order-request.model';
import {IOrderResultsPdfState} from '@app/order/models/my-order-state.model';
import {IOrderStatus} from '@app/shared/models/orderStatus.model';
import {environment} from '@environments/environment';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MyOrderService {
  private readonly _httpClient = inject(HttpClient);

  private readonly getOrders = `${environment.api.baseUrl}/${environment.api.checkout.getOrders}`;
  private readonly getOrderStatus = `${environment.api.baseUrl}/${environment.api.config.getOrderStatus}`;
  private readonly editOrderDetailsUrl = `${environment.api.baseUrl}/${environment.api.checkout.getEditOrder}`;
  private readonly getOrderResultsPdfDetailsUrl = `${environment.api.baseUrl}/${environment.api.checkout.getOrderPdfResults}`;
  private readonly getDownloadOrderResultsUrl = `${environment.api.baseUrl}/${environment.api.checkout.downloadOrderPdfResults}`;

  getListOfOrders(request: IMyOrderRequestModel): Observable<IOrdersDetails> {
    let params = new HttpParams().set('OrganizationId', request.organizationId.toString());

    if (request.patientName) {
      params = params.set('PatientName', request.patientName.toString());
    }

    if (request.physicianName) {
      params = params.set('PhysicianName', request.physicianName.toString());
    }

    if (request.orderId) {
      params = params.set('OrderId', request.orderId.toString());
    }

    if (request.orderStatusId) {
      params = params.set('OrderStatusId', request.orderStatusId.toString());
    }

    if (request.orderStartDate) {
      params = params.set('OrderCreateStartDate', request.orderStartDate.toString());
    }

    if (request.orderEndDate) {
      params = params.set('OrderCreateEndDate', request.orderEndDate.toString());
    }
    if (request.pageNumber) {
      params = params.set('PageNumber', request.pageNumber.toString());
    }
    if (request.pageSize) {
      params = params.set('PageSize', request.pageSize.toString());
    }
    if (request.sortField) {
      params = params.set('SortField', request.sortField.toString());
    }
    if (request.sortOption) {
      params = params.set('SortOption', request.sortOption.toString());
    }

    return this._httpClient.get<IOrdersDetails>(this.getOrders, {params});
  }

  getListOfOrderStatus(): Observable<IOrderStatus[]> {
    return this._httpClient.get<IOrderStatus[]>(`${this.getOrderStatus}`);
  }

  getEditOrderDetails(orderId: string): Observable<Order> {
    return this._httpClient.get<Order>(this.editOrderDetailsUrl + `${orderId}`);
  }

  getOrderResultsPdfDetails(orderId: string): Observable<IOrderResultsPdfState[]> {
    const params = new HttpParams().set('orderId', orderId);

    return this._httpClient.get<IOrderResultsPdfState[]>(this.getOrderResultsPdfDetailsUrl, {params});
  }

  downloadOrderResults(orderId: string, fileName: string): Observable<ArrayBuffer> {
    const params = new HttpParams().set('orderId', orderId).set('fileName', fileName);

    return this._httpClient.get<ArrayBuffer>(this.getDownloadOrderResultsUrl, {
      params: params,
      responseType: 'blob' as 'json',
    });
  }
}
